module.exports = __webpack_public_path__ + "static/media/warningRed.ddad69c5.svg";